<template lang="pug">
.layout
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
    v-card(min-height="80vh")
      v-card-title.px-5(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T16}`")
        v-row(no-gutters, align="center")
          v-col.shrink
            v-btn.ml-n3(text, icon, @click="showModal = !showModal", height)
              eva-icon(name="close-outline" :fill="$vuetify.theme.themes[$theme].basic800" width="24" height="24")
          v-col.ml-3
            p.mb-0.h6.basic800--text {{ $t('send_reminder') }}
      v-card-text(id="mainContainer")
        credit-alert(:credit="creditBalance" :showTitle="true")
        v-form(ref="form")
          v-row.py-2.px-3(style="margin:0 -23px; border-bottom:1px solid var(--v-basic400)")
            v-col
              .label.basic600--text.text-uppercase(id="formDataInvoices") {{ $t('income_invoice') }}
              v-select.my-2(v-model="form.invoices" background-color="basic200" outlined dense hide-no-data hide-details multiple readonly :items="form.invoices" :menu-props="({'closeOnContentClick': false})" placeholder="Add Invoices" :loading="invoicesSearchLoading" ref="selectInvoices" type="button" append-icon="")
                template(v-slot:selection="{ attrs, item, select, selected }")
                  v-chip.my-1.s2(v-if="form.invoices.length > 1" outlined :style="`background-color: ${$vuetify.theme.themes[$theme].basic600T08}`" close-icon="mdi-close" v-bind="attrs" small close color="basic600" :input-value="selected" @click:close="removeInvoice(item)")
                    span(v-if="item.name") {{`#${item.rid}`}} {{ item.name.length > 8 ? (item.name.substr(0,8) + '...') : item.name }}
                  .s1.basic800--text(v-else) {{`#${item.rid}`}} {{ item.name }}
                template(v-slot:append)
                  eva-icon(name="plus-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700" @click="showAttachInvoiceDialog = true")
          v-row.py-2.px-3(style="margin:0 -23px; border-bottom:1px solid var(--v-basic400)")
            v-col
              div.s1.textColorDefault--text(id="formDataChannels") {{ $t('how_would_you') }}
              div.p2.primary400--text {{ $t('please_ensure_you') }}
              //- div.d-flex.mt-4
              //-   y-checkbox.ma-0.pa-0(v-model="form.selectedChannels" hide-details value="whatsapp")
              //-     template(v-slot:label)
              //-       .p1.textColorDefault--text WhatsApp message sent from Yezza
              div.d-flex.mt-4
                y-checkbox.ma-0.pa-0(v-model="form.selectedChannels" hide-details value="sms")
                  template(v-slot:label)
                    .p1.textColorDefault--text {{ $t('sms_sent') }} ({{ channelPrice.sms | displayPrice }})
              div.d-flex.mt-4
                y-checkbox.ma-0.pa-0(v-model="form.selectedChannels" hide-details value="email")
                  template(v-slot:label)
                    .p1.textColorDefault--text {{ $t('email_sent') }}
              //- div.d-flex.mt-4
              //-   y-checkbox.ma-0.pa-0(v-model="form.selectedChannels" hide-details value="call")
              //-     template(v-slot:label)
              //-       .p1.textColorDefault--text Automated call
          v-row.py-2.px-3()
            div.d-flex.align-center.my-3
              div.mr-2.p2.primary500--text {{ $t('send_message_in') }} 
              v-menu(left :offset-y='true')
                template(v-slot:activator='{ on }')
                  v-chip.px-3(color="basic300" small label v-on="on")
                    div.button-AA-tiny.primary--text.text-uppercase {{ getFormLanguageDisplay() }}
                    v-icon.ml-1(right small) mdi-chevron-down
                v-list
                  v-list-item.my-n2(v-for="(language, index) in languages" :key="language.id" @click="form.language = language.id")
                    v-list-item-title.p2 {{ language.name }}
            v-card( flat outlined width="100%")
              v-card-text.pa-3
                div.s1.basic1000--text {{ $t('message_preview') }}:
                linkify-text.p1.primary400--text.mt-2(:text="formattedMessage(messagePreview, null)")
            //- v-btn.mx-3.button-Aa-small.custom-transform-class.text-none.px-2.mt-4(color="textColorAccent" text @click="showMessageTemplateDialog = true" small)
            //-       eva-icon.mt-1.mr-2(name="edit-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" height="14" width="14")
            //-       | Customize message
              
      v-card-actions
        v-spacer
        v-btn(color='white', text @click='showModal = !showModal')
          .button-Aa-medium.primary400--text {{ $t('cancel') }}
        v-btn.mr-2(color='info500' depressed @click="sendReminder" :loading="isLoading")
          .button-AA-medium.basic100--text {{ $t('send') }}
  .modals
    add-message-template(v-if="showMessageTemplateDialog" :open.sync="showMessageTemplateDialog" :message.sync="messageTemplate")
    attach-invoice(v-if="showAttachInvoiceDialog" :open.sync="showAttachInvoiceDialog" :initialInvoices.sync="form.invoices")
    low-balance(:open.sync="openLowBalanceDialog" :amount.sync="insufficientAmount")
    incomplete-info(v-if="openIncompleteDialog" :open.sync="openIncompleteDialog" :initialInvoices.sync="editIncompleteInvoices" :invoices="form.invoices" :channels="form.selectedChannels" @updated="handleUpdatedInfo")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CreditAlert from '@/components/yezzabook/dialogs/CreditAlert.vue'
import AddMessageTemplate from '@/components/yezzabook/dialogs/AddMessageTemplate.vue'
import AttachInvoice from '@/components/yezzabook/dialogs/AttachInvoices.vue'
import IncompleteInfo from '@/components/yezzabook/dialogs/IncompleteInfo.vue'
import LowBalance from '@/components/yezzabook/dialogs/LowBalance.vue'
import LinkifyText from '@/components/LinkifyText.vue'

export default {
  components:{CreditAlert, AttachInvoice, AddMessageTemplate, IncompleteInfo, LowBalance, LinkifyText},
  props: ["open", "selectedInvoices", "useStorage"],
  data: () => ({
    showAttachInvoiceDialog: false,
    showMessageTemplateDialog: false,
    openLowBalanceDialog: false,
    form: {
      invoices:[],
      selectedChannels: [],
      language: 'en',
    },
    openIncompleteDialog: false,
    editIncompleteInvoices: [],
    invoicesSearchLoading: false,
    languages: [
      { name: 'English', id: 'en' },
      { name: 'Bahasa Malaysia', id: 'ms' }
    ],
    isLoadingContact: false,
    isLoading: false,
    options: {
      duration: 200,
      offset: 0,
      easing: 'linear',
      container: '#mainContainer'
    },
    channelPrice: {
      sms: 20
    }
  }),
  mounted(){
    this.form.invoices = this.selectedInvoices || []
    if (this.useStorage && this.$store.state.reminder.data && this.$store.state.reminder.data.type === this.reminder.type){
      this.form = this.$store.state.reminder.data.form
    }
    this.$store.commit('reminder/setReminder', null)
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open;
      },
      set(newValue) {
        this.$emit("update:open", newValue);
      },
    },
    reminder () {
      return {
        type: 'default',
        form: this.form
      }
    },
    firstInvoice() {
      if (this.form.invoices.length == 0) {
        return null
      }
      return this.form.invoices[0]
    },
    creditBalance () {
      return this.company.prepaid_credits
    },
    insufficientAmount () {
      let price = 0
      const count = this.form.invoices.length
      if (this.form.selectedChannels.includes('sms')) {
        price += this.channelPrice.sms * count
      }
      const amount = this.creditBalance - price
      return amount < 0 ? Math.abs(amount) : 0
    },
    incompleteInvoices() {
      let invoices = []
      if (this.form.selectedChannels.includes('email') && this.form.selectedChannels.length >= 2) {
        invoices = this.form.invoices.filter(f => !f.email || !f.phone)
      } else if (this.form.selectedChannels.includes('email')) {
        invoices = this.form.invoices.filter(f => !f.email)
      } else {
        invoices = this.form.invoices.filter(f => !f.phone)
      }
      for (let i = 0; i < invoices.length; i++) {
        invoices[i].checked = true
      }
      return invoices
    },
    messagePreview () {
      return this.$t('template_message')
    },
    messageTitle() {
      return this.$t('template_title')
    }
  },
  watch: {
    invoices () {
      this.$emit("updateSelected", this.form.invoices)
    },
    // 'form.language' (val) {
    //   this.$i18n.locale = val
    // }
  },
  methods: {
    ...mapActions([
      'showMessage',
      'updateCompany'
    ]),
    getFormLanguageDisplay () {
      const selectedLanguage = this.languages.filter((obj) => {
        return obj.id == this.form.language
      })
      if (selectedLanguage.length > 0) {
        return selectedLanguage[0].name
      }
      return this.form.language
    },
    handleUpdatedInfo () {
      this.sendReminder()
    },
    async sendReminder () {
      if (!this.$refs.form.validate()) {
        return
      }
      if (this.form.invoices.length == 0) {
        this.showMessage(['error', this.$t('error_message.invoice_is_required')])
        this.$vuetify.goTo('#formDataInvoices', this.options)
        return
      }
      if (this.form.selectedChannels.length == 0) {
        this.showMessage(['error', this.$t('error_message.reminder_channel_required')])
        this.$vuetify.goTo('#formDataInvoices', this.options)
        return
      }
      if (this.incompleteInvoices.length != 0) {
        this.editIncompleteInvoices = [ ...this.incompleteInvoices ]
        this.openIncompleteDialog = true
        return
      }
      if (this.insufficientAmount) {
        this.openLowBalanceDialog = true
        return
      }
      this.isLoading = true
      let hasError = false
      let initialInvoices = [ ...this.form.invoices ]
      await this.asyncForEach(this.form.invoices, async (invoice) => {
        try {
          const data = {
            incomes: [invoice.id],
            channels: this.form.selectedChannels.map(m => m),
            message: this.formattedMessage(this.messagePreview, invoice),
            email_title: this.formattedMessage(this.messageTitle, invoice)
          }
          await this.$axios.post(`/books/${this.company.slug}/reminders/send`, data)
          initialInvoices = initialInvoices.filter((x) => x.pid !== invoice.pid)
        } catch (error) {
          hasError = true
        }
      })
      this.$emit("updateSelected", initialInvoices)
      this.isLoading = false
      if (hasError) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        return
      }
      this.fetchCompany()
      this.showModal = false
    },
    fetchCompany () {
      this.$axios.get(`/companies/${this.company.id}/`)
        .then(resp => {
          this.showMessage(['success', this.$t('success_message.reminder_sent')])
          this.updateCompany(resp.data)
        }).catch(() => {})
    },
    removeInvoice (item) {
      let index = this.form.invoices.map(m => { return m.id}).indexOf(item.id)
      if (index >= 0) this.form.invoices.splice(index, 1)
      this.$refs.selectInvoices.isMenuActive = false
      this.$emit('updateSelected', item)
    },
    formattedMessage (message, invoice) {
      let displayInvoice = invoice
      if (!displayInvoice) { displayInvoice = this.firstInvoice }
      message = message.split('{{company_name}}').join(this.company.name)
      if (displayInvoice) {
        message = message.split('{{customer_name}}').join(displayInvoice.name)
        message = message.split('{{amount_due}}').join(this.$options.filters.displayPrice(displayInvoice.amount_remaining))
        message = message.split('{{due_date}}').join(this.$options.filters.displayDate(displayInvoice.due_date))
        message = message.split('{{invoice_url}}').join(this.getShareLinkURL(displayInvoice))
      }
      return message
    },
    getShareLinkURL (invoice) {
      return `${process.env.VUE_APP_SHORT_URL_DOMAIN}/v/${invoice.pid}`
    }
  }
};
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "template_title": "Invoice reminder from {{company_name}}",
    "template_message": "Hi {{customer_name}},\n\nYour payment of {{amount_due}} to {{company_name}} is due on {{due_date}}.\nView & pay here:\n{{invoice_url}}\n\nThank you.",
    "email": {
      "label": "Email",
      "placeholder": "Email address"
    },
    "how_would_you": "How would you like us to send this reminder?",
    "please_ensure_you": "Please ensure you have enough balance to send reminders.",
    "sms_sent": "SMS sent from Yezza",
    "email_sent": "Email sent from Yezza",
    "send_message_in": "Send message in"
  },
  "ms": {
    "template_title": "Peringatan invois dari {{company_name}}",
    "template_message": "Hi {{customer_name}},\n\nBaki invois sebanyak {{amount_due}} kepada {{company_name}}. Sila buat pembayaran sebelum {{due_date}}.\nSemak & bayar di sini:\n{{invoice_url}}\n\nTerima kasih.",
    "email": {
      "label": "Email",
      "placeholder": "Email address"
    },
    "how_would_you": "How would you like us to send this reminder?",
    "please_ensure_you": "Please ensure you have enough balance to send reminders.",
    "sms_sent": "SMS sent from Yezza",
    "email_sent": "Email sent from Yezza",
    "send_message_in": "Send message in"
  }
}
</i18n>